import { render } from "./hotel_amenities.vue?vue&type=template&id=38175ea0"
import script from "./hotel_amenities.vue?vue&type=script&lang=js"
export * from "./hotel_amenities.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__